module.exports = {"611002001":"城关街道","611002002":"大赵峪街道","611002003":"陈塬街道","611002004":"刘湾街道","611002101":"夜村镇","611002104":"沙河子镇","611002105":"杨峪河镇","611002106":"金陵寺镇","611002107":"黑山镇","611002108":"杨斜镇","611002109":"麻街镇","611002111":"牧护关镇","611002112":"大荆镇","611002113":"腰市镇","611002114":"板桥镇","611002115":"北宽坪镇","611002119":"三岔河镇","611002121":"闫村镇","611002400":"二龙山水库","611002401":"南秦水库","611002402":"二龙山国营林场","611002403":"商丹循环工业园","611002404":"荆河工业园","611002405":"荆河农业示范园","611002406":"高校园区","611002407":"商洛职业技术学院","611002408":"氟化硅产业业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/611002.json
// module id = 2672
// module chunks = 0